// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"8116d7e2","213":"d8e6958b","453":"39c76752","454":"ed92d139","672":"1551bc0e","732":"90c7e47d"}[chunkId] + ".chunk.js";
};